<template>
  <v-row class="py-8">
    <v-col v-for="val in Properties" :key="val" cols="4" class="py-4">
      <v-row class="pl-10">
        <v-col cols="12" class="py-2">
          <h5 class="text-subtitle-2 pb-0 my-0 primary--text">
            {{ labels[val] || val }}:
          </h5>
        </v-col>

        <v-col cols="12" class="pl-3 py-0">
          <h5
            @click="goToCall(item[val], item.id)"
            v-if="val.toLocaleLowerCase().includes('telefono')"
            class="text-body-2 my-0 info--text"
            style="font-weight: 500 !important; cursor: pointer"
          >
            {{ item[val] }}&nbsp;<v-icon small color="info">
              mdi-phone
            </v-icon>
          </h5>
          <h5
            v-else
            class="text-body-2 my-0"
            style="font-weight: 500 !important"
          >
            {{ item[val] }}
          </h5>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
    },
  },
  data() {
    return {
      labels: {
        country: "Pais",
        updated_at: "Fecha de Act.",
        telefono1: "Telefono 1",
        telefono2: "Telefono 2",
        telefono3: "Telefono 3",
        telefono4: "Telefono 4",
        var1: "Variable 1",
        var2: "Variable 2",
        var3: "Variable 3",
        var4: "Variable 4",
        var5: "Variable 5",
        var6: "Variable 6",
        var7: "Variable 7",
        var8: "Variable 8",
        var9: "Variable 9",
        var10: "Variable 10",
      },
    };
  },
  computed: {
    Properties() {
      return Object.keys(this.item)
        .filter(
          (el) =>
            ![
              "id",
              "name",
              "dni",
              "direction",
              "created_at",
              "campaign_id",
              "user_id",
              "state",
              "status",
              "campaign",
            ].includes(el)
        )
        .filter((el) =>
          el.toLocaleLowerCase().includes("telefono")
            ? Boolean(Number(this.item[el]))
            : true
        );
    },
  },

  mounted() {
    this.actualizarLabels(); // Llamamos a la función cuando se monta el componente
  },

  methods: {
    goToCall(number, id) {
      this.$emit("goToCall", number, id);
      // console.log("number:", number);
    },

    openDialerDialog() {
      this.$store.dispatch("dialer/TOGGLE_OPEN_DIALOG");
    },

    actualizarLabels() {
      if (this.item.campaign && this.item.campaign.campaign_variable) {
        const variables = this.item.campaign.campaign_variable;

        for (let i = 1; i <= 10; i++) {
          const key = `var${i}`;
          if (variables[key] !== undefined) {
            this.labels[key] = variables[key];
          }
        }
      }
    }
  },
};
</script>

<style></style>
